import { format, parse } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import Config from 'config';

export default function formattedDate(dateString, fmt) {
  const config = new Config().getConfig();
  const dateTimeFormat = fmt || config.dateTimeFormat || 'EEE, MMMM d, yyyy, h:mmaaa';
  const parsedDate = new Date(dateString);
  const zonedDate = utcToZonedTime(parsedDate, config.timezone);

  return format(zonedDate, dateTimeFormat);
};

// Returns a timezoned date in a format that allows comparison i.e. date > now
export function comparableDate(dateStr) {
  const date = formattedDate(dateStr);
  const dateFormat = 'EEE, MMMM d, yyyy, h:mmaaa';

  return parse(date, dateFormat, new Date());
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/common/formattedDate.js